/**
 * P BOGOS Fix — vá định dạng tiền của app BOGOS.
 *
 * BOGOS tự format 2 chữ số thập phân ("509.000,00 ₫") thay vì đọc money_format
 * của store (đang đặt đúng "{{amount_no_decimals_with_comma_separator}}₫").
 * VND không có hào → cắt đuôi ",00". App không có setting nào tắt được.
 *
 * CHỐNG CHỚP TẮT: sửa NGAY trong callback của MutationObserver. Callback chạy ở
 * microtask, tức trước khi trình duyệt paint → không kịp hiện bản chưa sửa.
 * Bản đầu debounce 120ms nên BOGOS vẽ xong, paint rồi mới sửa → chớp liên tục.
 *
 * Ràng buộc:
 *  - Chỉ đụng text bên trong khối của BOGOS → không sờ giá của theme.
 *  - Không dùng requestAnimationFrame (ngừng chạy khi tab không compositing).
 *  - Hàm sửa IDEMPOTENT: chạy lại trên kết quả của chính nó không đổi gì nữa
 *    → observer tự hội tụ, không lặp vô hạn.
 *  - Không có BOGOS thì im lặng thoát, không văng lỗi.
 *
 * Lưu ý cho lần sau: emoji 🎁 trước tên quà KHÔNG phải do BOGOS — nó từng là
 * `.p-gift-line cart-item-title::before { content: '🎁 ' }` trong p-promo.css
 * của chính theme (đã gỡ 2026-08-08). Pseudo-element không nằm trong DOM nên
 * MutationObserver và textContent đều không thấy.
 */
(function () {
  'use strict';

  var CFG = (window.PPromoConfig && window.PPromoConfig.bogosFix) || {};
  if (CFG.money === false) return;

  var DEBUG = !!(window.PPromoConfig && window.PPromoConfig.debug);

  // Khối do BOGOS render. Thanh bar trong giỏ nằm trong .p-bogos-progress.
  var ROOTS = '[class*="bogos"],[class*="sca-fg"],.p-bogos-progress';

  // "509.000,00" → "509.000". (?!\d) chặn khớp nhầm vào nhóm nghìn.
  var RE_COMMA = /(\d),00(?!\d)/g;
  // "509.00 ₫" → "509 ₫". Nhóm nghìn luôn 3 chữ số nên ".00" không thể là nghìn.
  var RE_DOT = /(\d)\.00(?!\d)/g;

  var busy = false;

  function fixIn(root) {
    if (!root || root.nodeType !== 1) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var raw = node.nodeValue;
      if (!raw || raw.indexOf('00') === -1) continue;
      var next = raw.replace(RE_COMMA, '$1').replace(RE_DOT, '$1');
      if (next !== raw) node.nodeValue = next;
    }
  }

  /** Quét cả trang — lúc khởi động và vài mốc an toàn. */
  function fullSweep() {
    if (busy) return;
    busy = true;
    try {
      var roots = document.querySelectorAll(ROOTS);
      for (var i = 0; i < roots.length; i++) fixIn(roots[i]);
    } catch (e) {
      if (DEBUG) console.warn('[p-bogos-fix] sweep', e);
    }
    busy = false;
  }

  /** Sửa đồng bộ đúng nhánh vừa đổi, trước khi paint. */
  function onMutations(records) {
    if (busy) return;
    busy = true;
    try {
      for (var i = 0; i < records.length; i++) {
        var r = records[i];
        var el = r.target && r.target.nodeType === 1 ? r.target : r.target && r.target.parentElement;
        if (el && el.closest) {
          var root = el.closest(ROOTS);
          if (root) fixIn(root);
        }
        for (var a = 0; a < r.addedNodes.length; a++) {
          var n = r.addedNodes[a];
          if (n.nodeType === 1) fixIn(n);
        }
      }
    } catch (e) {
      if (DEBUG) console.warn('[p-bogos-fix] mutation', e);
    }
    busy = false;
  }

  function start() {
    fullSweep();

    if (window.MutationObserver) {
      new MutationObserver(onMutations).observe(document.documentElement, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    // BOGOS bắn event mỗi lần vẽ lại widget — quét lại cho chắc.
    [
      'fg-app:end',
      'bogos:cart-updated',
      'fg-gifts:updated',
      'bogos:progress-render',
      'bogos:product-discount-render',
      'bogos:volume-render'
    ].forEach(function (name) {
      document.addEventListener(name, fullSweep);
      window.addEventListener(name, fullSweep);
    });

    // Lưới an toàn cho đợt render muộn của app (không dùng rAF).
    [300, 1000, 2500, 5000].forEach(function (ms) { setTimeout(fullSweep, ms); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
